import { Link } from 'react-router-dom';
import Logo from '../../components/common/Logo.jsx';

const FEATURES = [
  { icon: '📹', title: 'Stream WebRTC temps réel', desc: 'Flux vidéo HD chiffré DTLS-SRTP depuis n\'importe quel appareil. Latence < 500ms.' },
  { icon: '🎯', title: 'Détection de mouvement', desc: 'Analyse image par image. Alertes instantanées par email, SMS et notification push.' },
  { icon: '☁️', title: 'Enregistrement cloud', desc: 'Clips automatiques stockés en S3. Rétention de 1 à 90 jours selon votre plan.' },
  { icon: '🌍', title: 'Accès mondial', desc: 'Surveillez depuis partout. Votre caméra = votre navigateur ou smartphone.' },
  { icon: '🔒', title: 'Sécurité militaire', desc: 'JWT + 2FA TOTP + chiffrement bout-en-bout. Score OWASP 9.6/10.' },
  { icon: '📊', title: 'Dashboard complet', desc: 'Vue multi-caméras 1×1, 2×2, 3×3. Timeline des alertes. Panel admin.' },
];

const PLANS = [
  { name: 'FREE', price: '0', currency: 'XOF', cameras: 1, retention: '1 jour', color: '#64748B', btn: 'Commencer gratuitement' },
  { name: 'STARTER', price: '2 500', currency: 'XOF/mois', cameras: 3, retention: '7 jours', color: '#00D4FF', btn: 'Choisir Starter', highlight: true },
  { name: 'PRO', price: '7 500', currency: 'XOF/mois', cameras: 10, retention: '30 jours', color: '#A855F7', btn: 'Choisir Pro' },
  { name: 'BUSINESS', price: 'Sur devis', currency: '', cameras: '∞', retention: '90 jours', color: '#F59E0B', btn: 'Nous contacter' },
];

const STATS = [
  { value: '< 500ms', label: 'Latence vidéo' },
  { value: '9.6/10', label: 'Score sécurité OWASP' },
  { value: '99.9%', label: 'Disponibilité cible' },
  { value: '4G/WiFi', label: 'Connexions supportées' },
];

export default function LandingPage() {
  return (
    <div style={{ background: '#060E1F', color: '#F1F5F9', fontFamily: 'system-ui, sans-serif', overflowX: 'hidden' }}>

      {/* NAV */}
      <nav style={{ position: 'sticky', top: 0, zIndex: 50, background: 'rgba(6,14,31,0.95)', backdropFilter: 'blur(12px)', borderBottom: '1px solid #1E3A5F', padding: '0 24px' }}>
        <div style={{ maxWidth: 1200, margin: '0 auto', display: 'flex', alignItems: 'center', justifyContent: 'space-between', height: 64 }}>
          <Logo size="sm" showText />
          <div style={{ display: 'flex', gap: 12 }}>
            <Link to="/login" style={{ padding: '8px 20px', borderRadius: 8, color: '#94A3B8', textDecoration: 'none', fontSize: 14 }}>
              Connexion
            </Link>
            <Link to="/register" style={{ padding: '8px 20px', borderRadius: 8, background: '#00D4FF', color: '#060E1F', textDecoration: 'none', fontSize: 14, fontWeight: 700 }}>
              Démarrer gratuitement
            </Link>
          </div>
        </div>
      </nav>

      {/* HERO */}
      <section style={{ padding: '96px 24px 80px', textAlign: 'center', position: 'relative' }}>
        <div style={{ position: 'absolute', inset: 0, background: 'radial-gradient(ellipse at 50% 0%, rgba(0,212,255,0.08) 0%, transparent 70%)', pointerEvents: 'none' }} />
        <div style={{ maxWidth: 760, margin: '0 auto', position: 'relative' }}>
          <span style={{ display: 'inline-block', background: 'rgba(0,212,255,0.1)', color: '#00D4FF', border: '1px solid rgba(0,212,255,0.3)', padding: '4px 16px', borderRadius: 20, fontSize: 12, fontWeight: 600, marginBottom: 24, letterSpacing: 1 }}>
            🎥 VIDÉOSURVEILLANCE INTELLIGENTE
          </span>
          <h1 style={{ fontSize: 'clamp(36px,6vw,64px)', fontWeight: 900, lineHeight: 1.1, margin: '0 0 20px', background: 'linear-gradient(135deg, #F1F5F9, #00D4FF)', WebkitBackgroundClip: 'text', WebkitTextFillColor: 'transparent' }}>
            Transformez n'importe quel appareil en caméra de surveillance
          </h1>
          <p style={{ fontSize: 18, color: '#94A3B8', margin: '0 0 40px', lineHeight: 1.6 }}>
            ELVYRA vous permet de surveiller vos locaux en temps réel depuis n'importe où dans le monde.
            Votre téléphone devient votre caméra. Votre navigateur devient votre poste de surveillance.
          </p>
          <div style={{ display: 'flex', gap: 12, justifyContent: 'center', flexWrap: 'wrap' }}>
            <Link to="/register" style={{ padding: '14px 32px', borderRadius: 10, background: '#00D4FF', color: '#060E1F', textDecoration: 'none', fontSize: 16, fontWeight: 700 }}>
              Démarrer gratuitement →
            </Link>
            <Link to="/login" style={{ padding: '14px 32px', borderRadius: 10, background: 'transparent', color: '#00D4FF', border: '1px solid #00D4FF', textDecoration: 'none', fontSize: 16, fontWeight: 600 }}>
              Se connecter
            </Link>
          </div>
          <p style={{ color: '#475569', fontSize: 13, marginTop: 16 }}>Aucune carte bancaire requise · Plan gratuit disponible</p>
        </div>
      </section>

      {/* STATS */}
      <section style={{ padding: '40px 24px', borderTop: '1px solid #1E3A5F', borderBottom: '1px solid #1E3A5F' }}>
        <div style={{ maxWidth: 900, margin: '0 auto', display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(180px,1fr))', gap: 32, textAlign: 'center' }}>
          {STATS.map(s => (
            <div key={s.label}>
              <div style={{ fontSize: 28, fontWeight: 800, color: '#00D4FF' }}>{s.value}</div>
              <div style={{ fontSize: 13, color: '#64748B', marginTop: 4 }}>{s.label}</div>
            </div>
          ))}
        </div>
      </section>

      {/* FEATURES */}
      <section style={{ padding: '80px 24px' }}>
        <div style={{ maxWidth: 1100, margin: '0 auto' }}>
          <h2 style={{ textAlign: 'center', fontSize: 36, fontWeight: 800, marginBottom: 8 }}>Tout ce dont vous avez besoin</h2>
          <p style={{ textAlign: 'center', color: '#64748B', marginBottom: 56 }}>Une plateforme complète, pensée pour l'Afrique et le monde.</p>
          <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(300px,1fr))', gap: 24 }}>
            {FEATURES.map(f => (
              <div key={f.title} style={{ background: '#0A1628', border: '1px solid #1E3A5F', borderRadius: 12, padding: 28 }}>
                <div style={{ fontSize: 36, marginBottom: 12 }}>{f.icon}</div>
                <h3 style={{ fontSize: 17, fontWeight: 700, margin: '0 0 8px' }}>{f.title}</h3>
                <p style={{ color: '#64748B', fontSize: 14, lineHeight: 1.6, margin: 0 }}>{f.desc}</p>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* HOW IT WORKS */}
      <section style={{ padding: '80px 24px', background: '#0A1628', borderTop: '1px solid #1E3A5F', borderBottom: '1px solid #1E3A5F' }}>
        <div style={{ maxWidth: 900, margin: '0 auto', textAlign: 'center' }}>
          <h2 style={{ fontSize: 36, fontWeight: 800, marginBottom: 48 }}>Comment ça marche ?</h2>
          <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(200px,1fr))', gap: 32 }}>
            {[
              { step: '01', title: 'Créez un compte', desc: 'Inscription gratuite en 30 secondes.' },
              { step: '02', title: 'Ajoutez une caméra', desc: 'Donnez un nom et un emplacement à votre caméra.' },
              { step: '03', title: 'Ouvrez Mode Caméra', desc: 'Sur votre téléphone ou PC, cliquez sur "Mode Caméra".' },
              { step: '04', title: 'Surveillez', desc: 'Regardez le flux en direct depuis n\'importe où.' },
            ].map(item => (
              <div key={item.step} style={{ textAlign: 'center' }}>
                <div style={{ width: 56, height: 56, borderRadius: '50%', background: 'rgba(0,212,255,0.1)', border: '2px solid rgba(0,212,255,0.3)', display: 'flex', alignItems: 'center', justifyContent: 'center', margin: '0 auto 16px', color: '#00D4FF', fontWeight: 800, fontSize: 18 }}>
                  {item.step}
                </div>
                <h4 style={{ fontWeight: 700, marginBottom: 8 }}>{item.title}</h4>
                <p style={{ color: '#64748B', fontSize: 14 }}>{item.desc}</p>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* PRICING */}
      <section style={{ padding: '80px 24px' }}>
        <div style={{ maxWidth: 1100, margin: '0 auto' }}>
          <h2 style={{ textAlign: 'center', fontSize: 36, fontWeight: 800, marginBottom: 8 }}>Tarifs simples et transparents</h2>
          <p style={{ textAlign: 'center', color: '#64748B', marginBottom: 56 }}>Paiement via CinetPay · Orange Money · Wave</p>
          <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(230px,1fr))', gap: 20 }}>
            {PLANS.map(p => (
              <div key={p.name} style={{
                background: p.highlight ? 'linear-gradient(135deg, rgba(0,212,255,0.08), rgba(0,212,255,0.03))' : '#0A1628',
                border: `2px solid ${p.highlight ? p.color : '#1E3A5F'}`,
                borderRadius: 16, padding: '32px 24px',
                transform: p.highlight ? 'scale(1.03)' : 'none',
              }}>
                {p.highlight && <div style={{ textAlign: 'center', color: '#00D4FF', fontSize: 11, fontWeight: 700, letterSpacing: 1, marginBottom: 12 }}>★ POPULAIRE</div>}
                <h3 style={{ color: p.color, fontWeight: 800, fontSize: 20, margin: '0 0 8px' }}>{p.name}</h3>
                <div style={{ margin: '12px 0 20px' }}>
                  <span style={{ fontSize: 32, fontWeight: 900 }}>{p.price}</span>
                  {p.currency && <span style={{ color: '#64748B', fontSize: 13, marginLeft: 4 }}>{p.currency}</span>}
                </div>
                <div style={{ display: 'flex', flexDirection: 'column', gap: 8, marginBottom: 24 }}>
                  <span style={{ color: '#94A3B8', fontSize: 14 }}>📹 {p.cameras} caméra{p.cameras !== 1 ? 's' : ''}</span>
                  <span style={{ color: '#94A3B8', fontSize: 14 }}>🗄 Rétention {p.retention}</span>
                  <span style={{ color: '#94A3B8', fontSize: 14 }}>✅ Détection mouvement</span>
                  <span style={{ color: '#94A3B8', fontSize: 14 }}>📧 Alertes email & SMS</span>
                </div>
                <Link to="/register" style={{
                  display: 'block', textAlign: 'center', padding: '12px', borderRadius: 8, textDecoration: 'none',
                  background: p.highlight ? p.color : 'transparent',
                  color: p.highlight ? '#060E1F' : p.color,
                  border: p.highlight ? 'none' : `1px solid ${p.color}`,
                  fontWeight: 700, fontSize: 14,
                }}>
                  {p.btn}
                </Link>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* CTA FINAL */}
      <section style={{ padding: '80px 24px', textAlign: 'center', background: 'linear-gradient(135deg, rgba(0,212,255,0.05), transparent)' }}>
        <h2 style={{ fontSize: 40, fontWeight: 900, marginBottom: 16 }}>Prêt à sécuriser vos locaux ?</h2>
        <p style={{ color: '#64748B', fontSize: 18, marginBottom: 32 }}>Rejoignez ELVYRA. Gratuit pour commencer.</p>
        <Link to="/register" style={{ padding: '16px 40px', borderRadius: 10, background: '#00D4FF', color: '#060E1F', textDecoration: 'none', fontSize: 18, fontWeight: 800 }}>
          Créer mon compte gratuit →
        </Link>
      </section>

      {/* FOOTER */}
      <footer style={{ borderTop: '1px solid #1E3A5F', padding: '32px 24px', textAlign: 'center' }}>
        <Logo size="sm" showText />
        <p style={{ color: '#334155', fontSize: 12, marginTop: 12 }}>
          © 2026 DEKANI SOFTWARE · Tous droits réservés ·{' '}
          <a href="mailto:contact@dekanisoftware.com" style={{ color: '#475569' }}>contact@dekanisoftware.com</a>
        </p>
      </footer>

    </div>
  );
}
